import CreditsOfferInfoLabel from './credits-offer-info-label';

export default CreditsOfferInfoLabel;
